import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  employeeName: "",
  employeeId: "",
  rols: [
    {
      idrole: 0,
      roleName: "",
      isActive: false,
      addToAll: false,
      country: {
        idcountry: 0,
        country1: "",
        isActive: false,
        createdBy: "",
        createdDate: "",
        modifiedBy: "",
        modifiedDate: "",
      },
    },
  ],
  userName: "",
  isActive: false,
  isAuthenticated: false,
  status: "idle", // 'idle', 'loading', 'succeeded', 'failed'
  error: null,
  failed: false,
};

export const signInSlice = createSlice({
  name: "signIn",
  initialState,
  reducers: {
    signInRequested: (state) => {
      state.status = "loading";
    },
    signInRequestFailed: (state, action) => {
      state.isLoading = true;
      state.error = action;
      state.failed = true;
    },
    signInRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.userName = action.payload.userName;
      state.employeeName = action.payload.employeeName;
      state.isAuthenticated = true;
    },
    resetAuthenticationState: (state) => {
      state.isAuthenticated = false;
      state.failed = false;
    },
    signOut: (state) => {
      state.isAuthenticated = false;
    },
    resetSignInState: (state) => {
      return { ...initialState, isAuthenticated: state.isAuthenticated };
    },
  },
});

export const {
  signInRequested,
  signInRequestFailed,
  signInRequestSucceeded,
  signOut,
  resetSignInState,
  resetAuthenticationState,
} = signInSlice.actions;

export default signInSlice.reducer;
